import React from "react"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import strings from "../../localization/strings"
import ImageLoader from "../../components/misc/ImageLoader"
import AccountStore from "../../stores/AccountStore"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import { IUIUser } from "../../models"
import { red500 } from "material-ui/styles/colors"
interface IProps {
    users: IUIUser[]
}

const EmployeeInfoTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <div className="UserTable" style={{ position: "relative" }}>
            <Table>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow >
                        <TableHeaderColumn style={styles.imageColumn} />
                        <TableHeaderColumn style={styles.columnHeader}>{strings.First_Name}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Last_Name}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{AccountStore.getExplicitEmployeeHierarchyAssignment() ? strings.Default_Hierarchy : strings.Punch_Hierarchy}</TableHeaderColumn>
                        {!AccountStore.getExplicitEmployeeHierarchyAssignment() &&
                            <TableHeaderColumn style={styles.columnHeader}>{strings.Default_Hierarchy}</TableHeaderColumn>
                        }
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Employee_ID}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} deselectOnClickaway={false} displayRowCheckbox={false}>
                    {props.users.map((row, i) => {
                        let smallImage
                        if (row.ProfileImageS3Url || row.ProfileImageID) {
                            smallImage = <ImageLoader url={row.ProfileImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + row.ProfileImageID} key={`smallImg-${i}`} />
                        }

                        const punchPermissionHierarchyName = hierarchyHelper.getFullyQualifiedLevelNameById(row.DefaultHierarchyItemId)
                        const defaultPunchHierarchyName = hierarchyHelper.getFullyQualifiedLevelNameById(row.DefaultPunchHierarchyId)

                        return (
                            <TableRow key={row.Id}>
                                <TableRowColumn style={styles.imageColumn}>{smallImage}</TableRowColumn>
                                <TableRowColumn style={styles.columnValue}><span title={row.FirstName}>{row.FirstName}</span></TableRowColumn>
                                <TableRowColumn style={styles.columnValue}><span title={row.LastName}>{row.LastName}</span></TableRowColumn>
                                <TableRowColumn style={styles.columnValue}>
                                    <span
                                        title={punchPermissionHierarchyName.includes(strings.Hierarchy_Removed) ? null : hierarchyHelper.getFullPathLabel(row.DefaultHierarchyItemId)}
                                        style={{ color: punchPermissionHierarchyName.includes(strings.Hierarchy_Removed) && red500 }}
                                    >
                                        {punchPermissionHierarchyName.includes(strings.Hierarchy_Removed) ? strings.Hierarchy_Removed : punchPermissionHierarchyName}
                                    </span>
                                </TableRowColumn>
                                {!AccountStore.getExplicitEmployeeHierarchyAssignment() &&
                                    <TableRowColumn style={styles.columnValue}>
                                        <span
                                            title={defaultPunchHierarchyName.includes(strings.Hierarchy_Removed) ? null : hierarchyHelper.getFullPathLabel(row.DefaultPunchHierarchyId)}
                                            style={{ color: defaultPunchHierarchyName.includes(strings.Hierarchy_Removed) && red500 }}
                                        >
                                            {defaultPunchHierarchyName.includes(strings.Hierarchy_Removed) ? strings.Hierarchy_Removed : defaultPunchHierarchyName}
                                        </span>
                                    </TableRowColumn>
                                }
                                <TableRowColumn style={styles.columnValue}>
                                    <span title={row.ExternalId}>{row.ExternalId}</span>
                                </TableRowColumn>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </div>
    )
}

export default EmployeeInfoTable

const styles = {
    columnValue: {
        textAlign: "left",
        cursor: "pointer",
        paddingLeft: 5,
        paddingRight: 5
    },
    columnHeader: {
        textAlign: "left",
        paddingLeft: 5,
        paddingRight: 5
    },
    imageColumn: {
        width: 40,
        textAlign: "center",
        paddingLeft: 5,
        paddingRight: 5,
    }
}
